import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay, switchMap, take } from 'rxjs';
import { ApolloClientService } from './apollo-client.service';
import { CategoriesQueries } from 'src/app/graphql/queries/categories.queries';
import { FpcFamily } from 'src/app/models/fpc-family';

interface PresignedUrlOutput {
  presignedUrl: string;
}

@Injectable({ providedIn: 'root' })
export class CategoriesService {
  private fpcFamilies$: Observable<FpcFamily[]> | null = null;

  constructor(
    private apolloClientService: ApolloClientService,
    private http: HttpClient
  ) {}

  getFpcFamilies$(): Observable<FpcFamily[]> {
    if (!this.fpcFamilies$) {
      this.fpcFamilies$ = this.apolloClientService.abstractionLayerClient$.pipe(
        take(1),
        switchMap(client =>
          client.query<{ configuratorFpcs: PresignedUrlOutput }>({
            query: CategoriesQueries.getCategories,
          })
        ),
        map(result => result?.data?.configuratorFpcs?.presignedUrl ?? ''),
        switchMap(url => this.http.get<any[]>(url, { withCredentials: false })),
        map(raw => (raw ?? []).map(fam => ({
          fpcCode: fam.fpcCode,
          name: fam.name,
          variants: (fam.variants ?? []).map((v: any) => ({
            fpcCode: v.fpcCode,
            name: v.name,
          }))
        } as FpcFamily))),
        shareReplay(1)
      );
    }
    return this.fpcFamilies$;
  }
}
